import { render, staticRenderFns } from "./bottomRightTop.vue?vue&type=template&id=fc5a5d86&scoped=true&"
import script from "./bottomRightTop.vue?vue&type=script&lang=js&"
export * from "./bottomRightTop.vue?vue&type=script&lang=js&"
import style0 from "./bottomRightTop.vue?vue&type=style&index=0&id=fc5a5d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5a5d86",
  null
  
)

export default component.exports